import script from "./Article.vue?vue&type=script&lang=ts&setup=true"
export * from "./Article.vue?vue&type=script&lang=ts&setup=true"

import "./Article.vue?vue&type=style&index=0&id=213117a5&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-213117a5"]])

export default __exports__